import api from './apiClient';

export const fetchInbounds = async (payload?: any) => {
  const response = await api.post('/inbounds/table', payload);
  return response.data;
};

export const finishInbound = (payload: any) => {
  return api.post('/inbounds/finish', payload);
};

export const fetchDestinationPoints = async (id: number): Promise<string[]> => {
  const response = await api.get(`/inbound/destination_points/${id}`);
  return response.data;
};

export const reserveBoxIds = async (count: number): Promise<string[]> => {
  const response = await api.post(`/inbound/reserve-ids`, {}, { params: { count } });
  return response.data.ids;
};
